export enum CandidateNotiType {
  System = "system",
  JobApply = "job_apply",
  JobApplyStatusChanged = "apply_status_changed",
}

export enum CandidateNotiSubjectType {
  Candidate = "candidate",
  Job = "job",
  Business = "business",
}

export interface NotificationMessageDto {
  id: string;
  businessId?: number;
  employeeId?: number;
  type?: CandidateNotiType;
  title?: string;
  content?: string;
  image?: string;
  actionUrl?: string;
  subject?: NotificationObject[];
  subjectCount?: number;
  diObject?: NotificationObject;
  inObject?: NotificationObject;
  prObject?: NotificationObject;
  isSeen?: boolean;
  isRead?: boolean;
}

export interface NotificationObject {
  id?: number;
  name?: string;
  type?: CandidateNotiSubjectType;
  uid?: string;
  image?: string;
  metadata?: Record<string, any>;
}

export function isNotificationMessageDto(data: any): boolean {
  return (
    data &&
    typeof data === "object" &&
    ("action_url" in data || "actionUrl" in data) &&
    "subject" in data
  );
}
